<div class="auto-expandable-cards container">
  @for (card of cards(); track i; let i = $index) {
    <button
      class="auto-expandable-card"
      [class.active]="activeIndex() === i"
      (click)="onCardClick(i)"
    >
      <app-video-player
        class="auto-expandable-card__video"
        [videoSrc]="card.video"
        (videoEntered)="onVideoEntered(i)"
      />

      <div class="auto-expandable-card__gradient"></div>

      <div class="auto-expandable-card__content">
        <div class="auto-expandable-card__header">
          <p class="auto-expandable-card__step type-body-b3">STEP {{ i + 1 }}</p>
          <p class="auto-expandable-card__title type-title-h8">{{ card.title }}</p>
        </div>

        <p class="auto-expandable-card__body type-body-b3">{{ card.description }}</p>
      </div>
    </button>
  }
</div>
